import { render, staticRenderFns } from "./PayerInformationApp.vue?vue&type=template&id=031faada&scoped=true"
import script from "./PayerInformationApp.vue?vue&type=script&lang=js"
export * from "./PayerInformationApp.vue?vue&type=script&lang=js"
import style0 from "./PayerInformationApp.vue?vue&type=style&index=0&id=031faada&prod&lang=less&scoped=true"
import style1 from "./PayerInformationApp.vue?vue&type=style&index=1&id=031faada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031faada",
  null
  
)

export default component.exports